
// SVG Icon: globe
export default { id: "terriajs-globe" };
export const id = "terriajs-globe";
export const name = "globe";
